// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itemDescription--dwWu1{font-size:inherit}`, "",{"version":3,"sources":["webpack://./src/component/CartItemDescription/index.module.scss"],"names":[],"mappings":"AAAA,wBACE,iBAAA","sourcesContent":[".itemDescription {\n  font-size: inherit;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemDescription": `itemDescription--dwWu1`
};
export default ___CSS_LOADER_EXPORT___;
